import { Box, Typography } from "@mui/material";
import { useSyles } from "./style";
import image from "../../assets/images/OG-logo-removebg-preview.png";
import useScrollToTop from "../../components/scrollTop";
const AboutUs = () => {
  const classes = useSyles();
  useScrollToTop();
  return (
    <>
      <Box p={4}>
        <Typography className={classes.title}>About Us</Typography>
      </Box>
      <Box className={classes.container}>
        <Box>
          <Typography className={classes.headings}>
            The Otago Gold Team{" "}
          </Typography>
          <Typography className={classes.description} py={2}>
            <Typography className={classes.headings}>
              Stephen Robinson (Co-Founder)
            </Typography>
            Australian based Stephen has decades of experience in the gold
            prospecting industry, having worked in mining operations both
            underground and above ground. His primary business interests now lay
            in media and advertising in both Australia and New Zealand. He heads
            up the corporate side of the project and ensures that Otago Gold is
            built on a foundation of sound industry practices.
          </Typography>
          <Typography className={classes.description} py={2}>
            <Typography className={classes.headings}>
              Christopher Pritchard (Co-Founder)
            </Typography>
            New Zealand based Christopher brings over 25 years of gold mining
            and business experience. His practical experience in the New Zealand
            mining theatre coupled with developing his own hospitality business
            has given him the unique skill set needed to drive the Otago Gold
            Project. Chris will manage the infield operations for the project.
          </Typography>
          <Typography className={classes.description} py={2}>
            Together, Stephen and Christopher’s combined 50+ years of experience
            gives the Otago Gold project a genuine level of relevant expertise.
          </Typography>
        </Box>
        <Box pb={3}>
          <img src={image} className={classes.image} alt="" />
        </Box>
      </Box>
    </>
  );
};

export default AboutUs;
